import type { FC, ReactNode } from 'react';

interface ErrorStateProps {
  children?: ReactNode;
}

const ErrorState: FC<ErrorStateProps> = ({ children }) => (
  <div className='mex:w-full mex:py-6 mex:text-center mex:text-red-500'>{children ?? 'Something went wrong!'}</div>
);

export default ErrorState;
